import React from "react";
import { Link } from "react-router-dom";
const SuccessStories = () => {
  return (
    <Link to="/blogs/success-story" className="block">
      <div class="font-sans max-w-6xl mx-auto p-4">
        <h1 class="text-3xl font-serif font-bold mb-6 border-b-4 border-pink-500 pb-3">
          Recent Stories
        </h1>

        <div class="flex flex-wrap gap-6 mb-10">
          {/* <!-- Feature Article --> */}
          <div class="flex-grow basis-2/3 min-w-[300px] relative">
            <img
              src="https://www.uptonbarn.com/wp-content/uploads/2024/07/Lucy-and-Yousef-High-Resolution-832-of-1006-scaled.jpg"
              alt="Business professional writing a proposal"
              class="w-full h-auto object-cover hover:scale-105 transition-transform duration-300"
            />
            <div class="absolute bottom-0 right-0 bg-pink-500 text-white p-4 max-w-[60%]">
              <div class="font-bold text-2xl">
                Master the Art of Proposal Writing
              </div>
              <div class="text-lg mt-2">10 Years In, Here's What Happened</div>
            </div>
          </div>

          {/* <!-- Side Article --> */}
          <div class="flex-grow basis-1/3 min-w-[250px]">
            <div class="mb-2 text-pink-500 font-bold">BUSINESS TIPS</div>
            <h2 class="text-xl font-serif font-bold mt-0">
              Master the Art of Proposal Writing. This is what it looks like
              when you don't fold...
            </h2>
            <p class="text-base leading-relaxed">
              Three rejections. One contract lost. Ten potential clients later,
              we're still here. Three successful bids.
            </p>
          </div>
        </div>

        {/* <!-- Bottom Articles Grid --> */}
        <div class="flex flex-wrap gap-6">
          {/* <!-- Article 1 --> */}
          <div class="flex-1 min-w-[250px] border-b-4 border-red-600 rounded-bl-md rounded-br-md">
            <img
              src="https://plus.unsplash.com/premium_photo-1690148812608-9942834931a1?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8d2VkZGluZ3xlbnwwfHwwfHx8MA%3D%3D"
              alt="Stack of business proposals"
              class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
            />
            <div class="my-2 text-pink-500 font-bold">BUSINESS STRATEGY</div>
            <h3 class="text-lg font-serif font-bold mt-0 hover:text-[#730000]">
              Structure Your Proposal Like a Pro: 5 Templates That Convert
            </h3>
            <p class="text-sm leading-relaxed">
              You planned to deliver a winning proposal—clear sections,
              compelling data, persuasive language. And then... deadline
              pressure. Your formatting falls apart. No consistent style, no
              cohesive structure.
            </p>
          </div>

          {/* <!-- Article 2 --> */}
          <div class="flex-1 min-w-[250px] border-b-4 border-red-600 rounded-bl-md rounded-br-md">
            <img
              src="https://plus.unsplash.com/premium_photo-1663076211121-36754a46de8d?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bWFycmlhZ2V8ZW58MHx8MHx8fDA%3D"
              alt="Digital marketing proposal on screen"
              class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
            />
            <div class="my-2 text-pink-500 font-bold">SELECTPROPOSAL</div>
            <h3 class="text-lg font-serif font-bold mt-0 hover:text-[#730000]">
              Did Your Last Proposal Win the Contract? The Inside Scoop of
              Business Success
            </h3>
            <p class="text-sm font-serif leading-relaxed">
              "Is that your proposal?" At this point, everyone has seen the huge
              difference between amateur and professional business proposals.
            </p>
          </div>

          {/* <!-- Article 3 --> */}
          <div class="flex-1 min-w-[250px] border-b-4 border-red-600 rounded-bl-md rounded-br-md">
            <img
              src="https://i0.wp.com/www.jenniferborisphotographyblog.com/wp-content/uploads/2020/11/townsend-hotel-community-house-birmingham-michigan-wedding-photo-176.jpg?resize=1000%2C667&ssl=1"
              alt="Calendar showing proposal deadline"
              class="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
            />
            <div class="my-2 text-pink-500 font-bold">COMMUNITY</div>
            <h3 class="text-lg font-serif font-bold mt-0 hover:text-[#730000]">
              When is the Best Time to Submit Your Proposal in 2025?
            </h3>
            <p class="text-sm leading-relaxed">
              We're already halfway through Q2, and we're about to enter the
              most critical proposal season. The last few weeks of the quarter
              are extra special, especially the odd days.
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SuccessStories;
